import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const Home = r => require.ensure(['@/components/Home'], () => r(require('@/components/Home')))
const MeetingLandingPage = r => require.ensure(['@/components/MeetingLandingPage'], () => r(require('@/components/MeetingLandingPage')))
const Cancel = r => require.ensure(['@/components/Cancel'], () => r(require('@/components/Cancel')))
const Reschedule = r => require.ensure(['@/components/Reschedule'], () => r(require('@/components/Reschedule')))
const MeetingNotFound = r => require.ensure(['@/components/NotFound'], () => r(require('@/components/NotFound')))

let routes = [
  { path: '/',
    component: Home,
    name: 'home'
  },
  { path: '/:prefixMeetingUrl?/:meetingTypeUrl?',
    component: MeetingLandingPage,
    name: 'meeting'
  },
  { path: '/:prefixMeetingUrl?/:meetingTypeUrl?/reschedule',
    component: Reschedule,
    name: 'reschedule'
  },
  { path: '/:prefixMeetingUrl?/:meetingTypeUrl?/cancel',
    component: Cancel,
    name: 'cancel'
  },
  { path: '/notFound',
    component: MeetingNotFound,
    name: 'notFound'
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// export Router instance
export default router
